// Chakra imports
import { Avatar, Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "../../../../components/card/Card";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getBusinessSlug } from '../../../../utils/slugify';
import {
  cloudinaryDeliveryUrl,
  coerceCloudinaryAbsoluteIfPartial,
} from '../../../../utils/cloudinaryDeliveryUrl';

// Logo URL'ini oluştur - dosya adını encode et; Cloudinary ise f_auto,q_auto + kare
const getLogoUrl = (logoPath) => {
  if (!logoPath) return undefined;

  const partialCloud = coerceCloudinaryAbsoluteIfPartial(logoPath);
  if (partialCloud) {
    return cloudinaryDeliveryUrl(partialCloud, 'square500');
  }

  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return cloudinaryDeliveryUrl(logoPath, 'square500');
  }
  
  // API URL'i al (fallback ile)
  let apiUrl = import.meta.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:5001';
  
  // Eğer URL'de protocol yoksa, production'da https ekle
  if (apiUrl && !apiUrl.startsWith('http://') && !apiUrl.startsWith('https://')) {
    // Production'da https kullan, development'ta http
    apiUrl = (process.env.NODE_ENV === 'production' ? 'https://' : 'http://') + apiUrl;
  }
  
  // Path'in başında / yoksa ekle
  const normalizedPath = logoPath.startsWith('/') ? logoPath : `/${logoPath}`;
  
  // Path'i encode et - sadece dosya adını encode et, path'i değil
  const pathParts = normalizedPath.split('/');
  const fileName = pathParts.pop();
  const encodedPath = pathParts.join('/') + '/' + encodeURIComponent(fileName);
  return cloudinaryDeliveryUrl(`${apiUrl}${encodedPath}`, 'square500');
};

export default function Banner(props) {
  const { avatar, name, branch, employee, followers, rank } = props;
  const navigate = useNavigate();
  
  // Avatar için logo URL'ini oluştur
  // Eğer avatar bir string ise ve logo path'i gibi görünüyorsa, getLogoUrl kullan
  // Aksi halde (örneğin default avatar image import'u), olduğu gibi kullan
  const logoUrl = typeof avatar === 'string' && (avatar.startsWith('/') || (!avatar.startsWith('http') && !avatar.startsWith('data:')))
    ? getLogoUrl(avatar)
    : avatar;
  
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const borderColor = useColorModeValue(
    "#f5f5f5 !important",
    "#111C44 !important"
  );

  const handleClick = () => {
    const businessSlug = getBusinessSlug();
    if (businessSlug) {
      navigate(`/admin/${businessSlug}/profil-ayarlari`);
    } else {
      navigate('/admin/profil-ayarlari');
    }
  };

  return (
    <Card 
      mb={{ base: "0px", lg: "20px" }} 
      align='center'
      cursor="pointer"
      onClick={handleClick}
      transition="all 0.2s"
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: 'lg'
      }}
    >
      <Box
        bg='linear-gradient(135deg, #545454 20%, #E45858 100%)'
        bgSize='cover'
        borderRadius='16px'
        h='131px'
        w='100%'
      />
      <Avatar
        mx='auto'
        src={logoUrl}
        h='87px'
        w='87px'
        mt='-43px'
        border='4px solid'
        borderColor={borderColor}
        onError={(e) => {
          // Logo yüklenemezse fallback göster
          e.target.style.display = 'none';
        }}
        fallback={
          <Box
            h='87px'
            w='87px'
            borderRadius='full'
            bg='gray.100'
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            <Text fontSize='2xl' fontWeight='bold' color='gray.400'>
              {name?.charAt(0)?.toUpperCase()}
            </Text>
          </Box>
        }
      />
      <Text color={textColorPrimary} fontWeight='bold' fontSize='xl' mt='10px'>
        {name}
      </Text>
      <Text color={textColorSecondary} fontSize='sm'>
        {branch}
      </Text>
      <Text 
        color="brand.500" 
        fontSize="xs" 
        fontWeight="500"
        mt="2"
      >
        Profil ayarlarını düzenlemek için tıklayın
      </Text>
      <Flex w='max-content' mx='auto' mt='26px'>
        <Flex mx='auto' me='60px' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {employee || 0}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Çalışan
          </Text>
        </Flex>
        <Flex mx='auto' me='60px' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {followers}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Takipçi
          </Text>
        </Flex>
        <Flex mx='auto' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {rank}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Sıralama
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
}